import { BaseI18nManager } from "../../../../i18n";

type Section = { [key: string]: string; };

export type Labels = {

    menu: string;
    view_all: string;
    highlighted: string;
    official_store: string;
    official_website: string;
    home: Section;
    facts: Section;
    store: Section;
    schedule: Section;
    gallery: Section;
    achievements: Section;
    team_history: Section;

}

export const i18nManager = new BaseI18nManager<Labels>({
    en_UK: require("./en_UK.json"),
});
